import React, { useCallback, useMemo } from 'react';
import { Keyboard, StyleSheet, View } from 'react-native';
import { rem, SettingsItem } from 'design-system';
import IconTagSolid from 'design-system/icons/IconTagSolid';
import IconBoldCheck from 'design-system/icons/IconBoldCheck';
import Modal from 'utils/packages/Modal';
import { isWeb } from '../../../constants';
const useCheckTransactionsModal = (justThisTransactionCb, checkSimilarTransactionsCb, overrideOptions) => {
    const options = useMemo(() => ({
        title: 'Which transactions should we update?',
        containerStyle: styles.modalContent,
        textStyle: styles.modalText,
    }), []);
    const open = useCallback((...args) => {
        Modal.show(<View>
          <SettingsItem icon={<IconBoldCheck />} iconSize={44} title="Just this one" onPress={() => justThisTransactionCb(...args)}/>
          <SettingsItem icon={<IconTagSolid />} iconSize={44} title="Check similar transactions" onPress={() => checkSimilarTransactionsCb(...args)}/>
        </View>, overrideOptions ? { ...options, ...overrideOptions(...args) } : options);
        Keyboard.dismiss();
    }, [
        overrideOptions,
        options,
        justThisTransactionCb,
        checkSimilarTransactionsCb,
    ]);
    return open;
};
const styles = StyleSheet.create({
    modalText: {
        ...(!isWeb && { paddingHorizontal: rem(48) }),
        marginBottom: rem(8),
    },
    modalContent: {
        paddingHorizontal: isWeb ? rem(8) : 0,
    },
    separator: {
        marginHorizontal: rem(16),
    },
});
export default useCheckTransactionsModal;
